"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/**
*
*
* @author Jeppe Sommer <jso@trifork.com>
**/
const RestUtils_1 = tslib_1.__importDefault(require("./RestUtils"));
const Entry_1 = tslib_1.__importDefault(require("./Entry"));
class URLPrefixMap {
    constructor() {
        this.entries = [];
    }
    put(prefix, value) {
        prefix = this.normalizePrefix(prefix);
        let searchResult = this.binarySearch(prefix);
        if (searchResult >= 0) {
            // Prefix already defined - just overwrite entry value
            this.entries[searchResult].value = value;
        }
        else {
            this.entries[this.entries.length] = new Entry_1.default(prefix, value);
            this.entries.sort(RestUtils_1.default.compare);
        }
    }
    remove(prefix) {
        prefix = this.normalizePrefix(prefix);
        let searchResult = this.binarySearch(prefix);
        if (searchResult >= 0) {
            window.alert("does this work?");
            return this.entries.splice(searchResult)[0].value;
        }
    }
    get(url) {
        let searchResult = this.binarySearch(url);
        if (searchResult >= 0) {
            // Exact match
            return this.entries[searchResult].value;
        }
        let insertionPoint = -searchResult - 1;
        if (insertionPoint < this.entries.length
            && this.entries[insertionPoint].prefix.length === (url.length + 1)
            && (!url.endsWith("/"))
            && this.entries[insertionPoint].prefix.startsWith(url)) {
            // Special case: url matches prefix, except that url doesn"t
            // end with "/"
            return this.entries[insertionPoint].value;
        }
        while (--insertionPoint >= 0) {
            if (url.startsWith(this.entries[insertionPoint].prefix)) {
                return this.entries[insertionPoint].value;
            }
        }
    }
    containsKey(url) {
        url = this.normalizePrefix(url);
        const searchResult = this.binarySearch(url);
        if (searchResult >= 0) {
            return true;
        }
        return false;
    }
    isEmpty() {
        return this.size() === 0;
    }
    size() {
        return this.entries.length;
    }
    values() {
        const result = [];
        for (let i = 0; i < this.entries.length; i++) {
            result.push(this.entries[i].value);
        }
        return result;
    }
    matches(url, prefix) {
        if (prefix.length === url.length + 1 && url.length > 0 && url.charAt(url.length - 1) !== "/") {
            // Check for special case: url matches prefix, except that url doesn"t end with "/"
            prefix = prefix.substring(0, prefix.length - 1);
        }
        return url.startsWith(prefix);
    }
    binarySearch(key) {
        let low = 0;
        let high = this.entries.length - 1;
        while (low <= high) {
            const mid = (low + high) >>> 1;
            const midVal = this.entries[mid];
            const cmp = RestUtils_1.default.compare(midVal, key);
            if (cmp < 0) {
                low = mid + 1;
            }
            else if (cmp > 0) {
                high = mid - 1;
            }
            else {
                return mid; // key found
            }
        }
        return -(low + 1); // key not found.
    }
    normalizePrefix(prefix) {
        if (prefix.length > 0 && !prefix.endsWith("/")) {
            return prefix + "/";
        }
        return prefix;
    }
}
exports.default = URLPrefixMap;
//# sourceMappingURL=URLPrefixMap.js.map